import sectionCardStepInstructions02Css from '../css-snippets/section-card-step-instructions-02';

const html = ` 
<style>${sectionCardStepInstructions02Css}</style>
<div
  id="card-step-instructions-wrapper-unique-id"
  data-id="unique-id"
  class="card-step-instructions-wrapper"
  data-attribute="card-step-instructions-wrapper"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  data-items-per-row-mobile="1"
  data-items-per-row-desktop="4"
  data-odd-background="#14a16c"
  data-odd-text-color="#ffffff"
  data-even-background="#e1e1e1"
  data-even-text-color="#000000"
  data-item-image-height="150"
  style="
    --background-color: #ffffff;
    --text-color: #000000;
    --items-per-row-mobile: 1;
    --items-per-row-desktop: 4;
    --odd-background: #14a16c;
    --odd-text-color: #ffffff;
    --even-background: #e1e1e1;
    --even-text-color: #000000;
    --item-image-height: 150px;
  "
>
  <div
    data-attribute="card-step-instructions-container"
    class="card-step-instructions-container container"
  >
    <div
      class="card-step-instructions-header"
      data-attribute="card-step-instructions-header"
    >
      <h2 style="text-align: center">
        <strong
          >Experience a Stronger Respiratory Health <br />
          In 3 Months with Lignosus</strong
        >
      </h2>
      <p style="text-align: center">
        Based on thousands of customer testimonials, we have put together a
        journey map that summarizes their progress in <br />
        achieving a better respiratory health
      </p>
    </div>
    <div
      class="card-step-instructions-list"
      data-attribute="card-step-instructions-list"
    >
      <div
        class="card-step-instructions-item"
        data-attribute="card-step-instructions-item"
      >
        <div
          class="card-step-instructions-item-title"
          data-attribute="card-step-instructions-item-title"
        >
          Within 7 Days
        </div>
        <div
          class="card-step-instructions-item-image"
          data-attribute="card-step-instructions-item-image"
        >
          <img
            data-attribute="card-step-instructions-item-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69d9ed45411616b8d572ad7f.png?w=500&h=50&q=80"
            alt="img"
          />
        </div>
        <div
          class="card-step-instructions-item-content"
          data-attribute="card-step-instructions-item-content"
        >
          With the fast-acting herbal ingredients in Lignosus, many customers report that they feel an improvement in their respiratory issues within just a few days of their very first try of the product.
        </div>
      </div>
      <div
        class="card-step-instructions-item"
        data-attribute="card-step-instructions-item"
      >
        <div
          class="card-step-instructions-item-title"
          data-attribute="card-step-instructions-item-title"
        >
          1 Month
        </div>
        <div
          class="card-step-instructions-item-image"
          data-attribute="card-step-instructions-item-image"
        >
          <img
            data-attribute="card-step-instructions-item-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69d9ed57fa54413a15655fb6.png?w=500&h=50&q=80"
            alt="img"
          />
        </div>
        <div
          class="card-step-instructions-item-content"
          data-attribute="card-step-instructions-item-content"
        >
          Within the next few weeks, anti-inflammatory and anti-microbial properties of Lignosus Organic Tiger Milk Mushroom help to fight inflammation in the respiratory tract and support easy respiration by maintaining open and clear nasal passages.
        </div>
      </div>
      <div
        class="card-step-instructions-item"
        data-attribute="card-step-instructions-item"
      >
        <div
          class="card-step-instructions-item-title"
          data-attribute="card-step-instructions-item-title"
        >
          2 Months
        </div>
        <div
          class="card-step-instructions-item-image"
          data-attribute="card-step-instructions-item-image"
        >
          <img
            data-attribute="card-step-instructions-item-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69d9ed6743937e3de10c0fbe.png?w=500&h=50&q=80"
            alt="img"
          />
        </div>
        <div
          class="card-step-instructions-item-content"
          data-attribute="card-step-instructions-item-content"
        >
          Immunoregulatory properties of Lignosus Organic Tiger Milk Mushroom continue to stabilize the respiratory condition, enhance lung functions, and repair cellular damage in the respiratory system.
        </div>
      </div>
      <div
        class="card-step-instructions-item"
        data-attribute="card-step-instructions-item"
      >
        <div
          class="card-step-instructions-item-title"
          data-attribute="card-step-instructions-item-title"
        >
          3 Months
        </div>
        <div
          class="card-step-instructions-item-image"
          data-attribute="card-step-instructions-item-image"
        >
          <img
            data-attribute="card-step-instructions-item-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69d9ed6743937e3de10c0fbe.png?w=500&h=50&q=80"
            alt="img"
          />
        </div>
        <div
          class="card-step-instructions-item-content"
          data-attribute="card-step-instructions-item-content"
        >
          As the cumulative healing effect of the herbal active ingredients in the Lignosus Organic Tiger Milk Mushroom continues to compound, many customers feedback that their respiratory issues have improved and they feel their respiratory, lungs and sinus are healthier. Continue taking Lignosus to support healthy airway function
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
